import { has } from 'lodash'

type Has = typeof has

export const objectHas: Has = has
